<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="90" :isOpen="isOpen" :closeCompleteAction="() => { closeCompleteAction(PROFILE_BOX_LIST.CAREER, true, false, false) }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction(PROFILE_BOX_LIST.CAREER, true, false, false)" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">실력/구력</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">회원님의 축구 실력과<br>구력을 변경할 수 있습니다</div>
                </div>
                <div>
                    <div style="margin-top: 20px;">
                        <div class="title">실력</div>
                        <div class="common_box_wrap">
                            <div v-for="each, i in skill" :key="i" @click='setSelectSkill(each.id)' :style="{ backgroundColor: each.id === selectedSkill ? '#210f03' : '#fff', color: each.id === selectedSkill ? '#fff' : '#210f03' }" class="common_box_circle">
                                <div class="common_text">{{ each.title }}</div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 32px;">
                        <div class="title">구력</div>
                        <div class="common_box_wrap">
                            <div v-for="each, i in lengthOfPlay" :key="i + 'lengthOfPlay'" @click='setSelectLengthOfPlay(each.id)' :style="{ backgroundColor: each.id === selectedLengthofPlay ? '#210f03' : '#fff', color: each.id === selectedLengthofPlay ? '#fff' : '#210f03' }" class="common_box">
                                <div class="common_text">{{ each.title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="selectedLengthofPlay !== '' && selectedSkill !== ''" class="save_btn_active">저장하기</div>
                <div v-else class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode'
import { PROFILE_BOX_LIST } from '@/Constants'

export default {
    name: 'SettingPlayStyle',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            selectedLengthofPlay: '',
            selectedSkill: '',
            skill: [
                { title: '하🔻', id: '하' },
                { title: '중하', id: '중하' },
                { title: '중', id: '중' },
                { title: '중상', id: '중상' },
                { title: '상🔺', id: '상' },
            ],
            lengthOfPlay: [
                { title: '1년 미만', id: '1년 미만' },
                { title: '1~2년', id: '1~2년' },
                { title: '2~5년', id: '2~5년' },
                { title: '5~9년', id: '5~9년' },
                { title: '10년 이상', id: '10년 이상' },
            ],
            PROFILE_BOX_LIST: PROFILE_BOX_LIST
        }
    },
    methods: {
        setSelectLengthOfPlay(lengthOfPlay) {
            this.selectedLengthofPlay = lengthOfPlay
        },
        setSelectSkill(skill) {
            this.selectedSkill = skill
        },
        async save() {
            if (this.selectedSkill === '') {
                this.$GlobalStore.showAlert('실력을 선택해주세요.')
                return
            }

            if (this.selectedLengthofPlay === '') {
                this.$GlobalStore.showAlert('구력을 선택해주세요.')
                return
            }

            this.$GlobalStore.showProgress()

            const formData = new FormData()
            formData.append('level', this.selectedSkill)
            formData.append('career', this.selectedLengthofPlay)

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.selectedSkill = ''
                this.selectedLengthofPlay = ''
                this.$GlobalStore.hideProgress()
                this.closeCompleteAction(PROFILE_BOX_LIST.CAREER, true, false, true)
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.selectedLengthofPlay = ''
                this.selectedSkill = ''
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.title {
    margin-bottom: 16px;
    font-weight: 500;
}

.common_box_wrap {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.common_box {
    width: 110px;
    text-align: center;
    padding: 8px;
    border: 1px solid #d9d9d9;
    border-radius: 12px;
}

.common_box_circle {
    border: 1px solid #d9d9d9;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.common_text {
    font-weight: 500;
    line-height: 24px;
    white-space: nowrap;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}
</style>